/**
 * 日期格式化工具函数
 */

/**
 * 格式化日期为中文格式
 * @param {String|Date} text - 日期字符串或Date对象
 * @param {Boolean} includeSeconds - 是否包含秒
 * @returns {String} 格式化后的日期字符串
 */
export function formatDate(text, includeSeconds = true) {
  if (!text) return '';
  
  const da = new Date(text);
  
  // 检查日期是否有效
  if (isNaN(da.getTime())) {
    return text;
  }
  
  const year = da.getFullYear() + '年';
  const month = (da.getMonth() + 1) + '月';
  const date = da.getDate() + '日';
  const hour = da.getHours() + '时';
  const min = da.getMinutes() + '分';
  
  const dateStr = [year, month, date].join('');
  const timeStr = includeSeconds 
    ? [hour, min, da.getSeconds() + '秒'].join('') 
    : [hour, min].join('');
  
  return dateStr + ' ' + timeStr;
}

/**
 * 获取相对时间描述
 * @param {String|Date} text - 日期字符串或Date对象
 * @returns {String} 相对时间描述（如：刚刚、5分钟前、2天前等）
 */
export function getRelativeTime(text) {
  if (!text) return '';
  
  const date = new Date(text);
  const now = new Date();
  const diff = now - date;
  
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const months = Math.floor(days / 30);
  const years = Math.floor(days / 365);
  
  if (seconds < 60) return '刚刚';
  if (minutes < 60) return `${minutes}分钟前`;
  if (hours < 24) return `${hours}小时前`;
  if (days < 30) return `${days}天前`;
  if (months < 12) return `${months}个月前`;
  return `${years}年前`;
}

